import { createContext, useContext, useMemo, useState } from 'react';

import { IDraftOrder } from '@customTypes/draftOrder';

interface IDraftOrderDetailContextProps {
  draftOrder: IDraftOrder | null;
  loading: boolean;
  setDraftOrder: React.Dispatch<React.SetStateAction<IDraftOrder | null>>;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
}

interface Props {
  children: React.ReactNode;
}

const DraftOrderDetailContext = createContext<IDraftOrderDetailContextProps>({} as IDraftOrderDetailContextProps);

export const DraftOrderDetailProvider: React.FC<Props> = ({ children }) => {
  const [draftOrder, setDraftOrder] = useState<IDraftOrder | null>(null);
  const [loading, setLoading] = useState<boolean>(false);

  const memoedContextValue = useMemo(
    () => ({
      draftOrder,
      loading,
      setDraftOrder,
      setLoading,
    }),
    [draftOrder, loading],
  );

  return <DraftOrderDetailContext.Provider value={memoedContextValue}>{children}</DraftOrderDetailContext.Provider>;
};

export default function useDraftOrderDetail() {
  return useContext(DraftOrderDetailContext);
}
